import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, Subject, of, forkJoin } from 'rxjs';
import { Auth, IAuth } from '../models/auth.model';
import { AppHttpClient } from './app-http-client.service';
import { LocalStorageService } from './local-storage.service';
import { UserService } from './user.service';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import OktaAuth, { AuthState } from '@okta/okta-auth-js';
import { UtilService } from './util.service';
import { ROLE_BY_PERMISSIONS } from '../enums/ui.enum';
import { USER_ROLES } from '../enums/user.enum';
import { AuthService } from './auth.service';
import { CustomSpinnerService } from '../interceptors/custom-spinner.service';

@Injectable({
  providedIn: 'root',
})
export class AuthOktaService {
  private unsubscriber: Subject<void> = new Subject<void>();
  public isAuthenticated!: boolean;
  // Navigate to Home only on the first sign-in; background token renewals re-emit authState
  // and must not yank the user back to Home mid-session.
  private hasNavigated = false;
  constructor(
    private router: Router,
    public ls: LocalStorageService,
    public userService: UserService,
    private http: AppHttpClient,
    private util: UtilService,
    private spin: CustomSpinnerService,
    private authService: AuthService,
    private _oktaStateService: OktaAuthStateService,
    @Inject(OKTA_AUTH) private _oktaAuth: OktaAuth
  ) { }

  OktaInit() {
    this.spin.show();
    this._oktaStateService.authState$.subscribe({
      next: (authState: AuthState) => {
        console.log({ authState });
        this.spin.hide();
        this.isAuthenticated = authState.isAuthenticated || false;
        if (authState.isAuthenticated) {
          this.validateToken(authState);
        }
      },
      error: (err) => {
        console.log({ err });
        this.util.openMsgDialog('Unable to complete login', 'We ran into a problem');
      }
    });
  }

  validateToken(auth: AuthState) {
    this.http.get("validateToken", {token:auth.idToken?.idToken})
    .subscribe({
      next:(res:any)=>{
        console.log({res});
        if (auth.idToken?.idToken) {
          this.authService.setAuth(new Auth({token:res.token}));
          this.userService.fetchUser(res.token, ROLE_BY_PERMISSIONS);
          // Only route to Home on the initial sign-in, not on background token renewals.
          if (!this.hasNavigated) {
            this.hasNavigated = true;
            this.router.navigate(['/admin/home']);
          }
        } else {
          this.util.openMsgDialog('Unable to complete login', 'We ran into a problem');
        }
      },
      error:()=>{
        this.util.openMsgDialog('Unable to complete login', 'We ran into a problem');
      }
    });
  }

  public async oktaSignIn(): Promise<void> {
    await this._oktaAuth.signInWithRedirect();
  }

  public async oktaSignOut(): Promise<void> {
    this.authService.logout();
  }

}
